export default __webpack_public_path__ + "static/media/about-page-img.ac06f5fd.png";